import axios from 'axios';
import { Toastify } from 'lift-ui';

export const super_admin = (admin_auth: any) => {
  return async (dispatch: any) => {
    try {
      if (admin_auth) {
        dispatch({
          type: 'SUPERADMIN_SUCESS',
        });
      } else {
        dispatch({
          type: 'SUPERADMIN_ERROR',
        });
      }
    } catch (error) {
      dispatch({
        type: 'SUPERADMIN_ERROR',
      });
    }
  };
};

export const auth_check = (admin_auth: any) => {
  return async (dispatch: any) => {
    try {
      if (admin_auth != null) {
        dispatch({
          type: 'ADMIN_AUTH_SUCESS',
          payload: {
            admin_auth: admin_auth,
          },
        });
      } else {
        dispatch({
          type: 'ADMIN_AUTH_ERROR',
        });
      }
    } catch (error) {
      dispatch({
        type: 'ADMIN_AUTH_ERROR',
      });
    }
  };
};

export const logout_admin = () => {
  return async (dispatch: any) => {
    try {
      sessionStorage.removeItem('register');
      dispatch({
        type: 'ADMIN_LOGOUT',
      });
    } catch (error: any) {
      Toastify('error', error.response?.data?.message);
      console.log(error, 'logout error');
    }
  };
};
